<template lang="pug">
div.mb-5
  app-sublayer-header  Специализация судьи
  app-empty-list(v-if="currentJudge.judgeSpecialisation.length == 0") Список пуст
  app-group-animation
    app-group-item(v-for="s in currentJudge.judgeSpecialisation" :key="s.id" cols="12")
      app-card(@click.native="moveSpecialization(s)")
        app-card-body
          app-card-title {{ s.specialisationType.title }}
          app-card-caption {{ s.address ? s.address : 'Не определен' }}
  SpecialisationDel(v-model="dialog.delSpecialisation" :specialisation="form.specialisation")
</template>


<script>
import { AppDialogToggable } from '@/components'
import { mapState } from 'vuex'
import SpecialisationDel from './SpecialisationDel'

let defaultSpesialisation = {
  specialisationType: '',
  address: '',
  id: ''
}

export default {
  mixins: [AppDialogToggable],
  components: {
    SpecialisationDel
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge'])
  },

  methods: {
    moveSpecialization (s) {
      if (this.currentJudge.archive) return null
      this.form.specialisation = s
      this.dialog.delSpecialisation = true
    },
  },

  data () {
    return {
      dialog: {
        delSpecialisation: false,
      },
      form: {
        specialisation: defaultSpesialisation
      }
    }
  }
}
</script>